import React from "react";
import _ from "lodash";

import { Icon, arrowSwapColor } from "Icons/index";

import cx from "classnames";
import s from "./multipleSelector.scss";
import t from "Utils/translation";

export default class MultipleSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: props.options || [],
      second: props.selected || [],
      isFiltering: false,
      filterValue: undefined,
      filterdValues: []
    };
  }

  componentDidMount() {
    this.props.onChange({ [this.props.name]: this.state.second.map(x => x.value) });
  }

  filter(event) {
    let filterValue = event.target.value;

    if (filterValue) {
      this.setState({ isFiltering: true, filterValue: filterValue });
    } else {
      this.setState({ isFiltering: false, filterValue: undefined });
    }

    var firsts = _.filter(this.state.first, x => {
      return !!x.label.match(new RegExp(filterValue));
    });
    this.setState({ filterdValues: firsts });
  }

  moveToRight(obj) {
    var seconds = this.state.second;
    seconds.push(obj);
    var firsts = _.filter(this.state.first, x => {
      return x.label !== obj.label;
    });
    this.setState({ first: firsts });
    this.setState({ second: seconds });
    this.props.onChange({ [this.props.name]: seconds.map(x => x.value) });
    if (this.state.isFiltering) {
      firsts = _.filter(this.state.filterdValues, x => {
        return x.label !== obj.label;
      });
      this.setState({ filterdValues: firsts });
    }
  }

  moveToLeft(obj) {
    var firsts = this.state.first;
    firsts.push(obj);
    var seconds = _.filter(this.state.second, x => {
      return x.label !== obj.label;
    });
    this.setState({ first: firsts });
    this.setState({ second: seconds });
    this.props.onChange({ [this.props.name]: seconds.map(x => x.value) });
    if (this.state.isFiltering) {
      firsts = _.filter(this.state.first, x => {
        return !!x.label.match(new RegExp(this.state.filterValue));
      });
      this.setState({ filterdValues: firsts });
    }
  }

  render() {
    const { className, firstPanelTitle, secondPanelTitle, errors, label } = this.props;
    let toShow;
    if (this.state.isFiltering) {
      toShow = this.state.filterdValues;
    } else {
      toShow = this.state.first;
    }

    return (
      <div className={cx(className, s.multipleSelector)}>
        <label className={s.label}>{label}</label>

        <input
          className={s.input}
          placeholder={t("input.placeholder.filters")}
          onChange={this.filter.bind(this)}
        />

        <div className={s.wrapPanel}>
          <div className={s.headerLeft}>{firstPanelTitle}</div>
          <div className={s.headerRight}>{secondPanelTitle}</div>
          <div className={s.listLeft}>
            {toShow.map((x, i) => {
              return (
                <div className={s.listItem} key={i} onClick={() => this.moveToRight(x)}>
                  {x.label}
                </div>
              );
            })}
          </div>

          <div className={s.icon}>
            <Icon svg={arrowSwapColor} width="1rem" height="1rem" />
          </div>

          <div className={s.listRight}>
            {this.state.second.map((x, i) => {
              return (
                <div className={s.listItem} key={i} onClick={() => this.moveToLeft(x)}>
                  {x.label}
                </div>
              );
            })}
          </div>
        </div>
        <div className={s.errors}>{errors}</div>
        {/*
        <div className={s.container}>
          <div className={s.leftTitle}>{firstPanelTitle}</div>
          <div className={s.rightTitle}>{secondPanelTitle}</div>
          <div className={s.leftPanel}>
            <ul>
              {toShow.map((x, i) => {
                return (
                  <li key={i} onClick={() => this.moveToRight(x)}>
                    {x.label}
                  </li>
                );
              })}
            </ul>
          </div>
          <div className={s.rightPanel}>
            <ul>
              {this.state.second.map((x, i) => {
                return (
                  <li key={i} onClick={() => this.moveToLeft(x)}>
                    {x.label}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <span>{errors}</span>
        */}
      </div>
    );
  }
}
